// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__14cIC","left":"InfoRow_left__yN-UA"};